import React, { useState } from 'react';
import withContext from "../withContext";
import CartItem from "./CartItem";

import axios from 'axios';


const Cart = props => {
  const { cart } = props.context;
  const [error, setError] = useState("No item in cart!");
  const [phone, setPhone] = useState(0);
  const [address, setAddress] = useState("");
  const [deliver, setDeliver] = useState("");
    
  const cartKeys = Object.keys(cart || {});

  function getTotal(){
      let total = 0; 
      cartKeys.map(key => {
          console.log("here: " + JSON.stringify(cart[key]));
          total += cart[key].amount *  cart[key].product.price
      })
      return total;
  }

   function getOrderSummary(){
      let orderText = ""
       
      cartKeys.map(key => {
//          console.log("here: " + JSON.stringify(cart[key]));
          orderText += cart[key].product.name + ": " + cart[key].amount + ": $" + cart[key].product.price + " each ";
//          total += cart[key].amount *  cart[key].product.price
      })
      return orderText;
  }

    
  function handleTextChange(e) {
      if(e.target.name == "phone") setPhone(e.target.value)
      if(e.target.name == "address") setAddress(e.target.value)
      if(e.target.name == "deliver") setDeliver(e.target.value)
  }
    
async function onCheckout(){
    //TODO: 1. Display a message that the order has been sent
    //2. SEnd the message using twilio to the guy
    console.log("phone: " + phone)    
    //TODO: Send a POST request to the Google Scripts to save the data and send it 
 
   let messsage = 
       "Phone Number: " + phone + " | "
       + "Address: " + address + " | "
       + "Delivery instructions: " + deliver + " | "
       + "Order details: " + getOrderSummary() + " | "
       + "Total: $" + getTotal();
       
   console.log("usl: " + encodeURIComponent(messsage))
       //https://script.google.com/macros/s/AKfycbwqn0EoECBkGEhrLaJE0NmD7kRoEcFzec6sjJL6eWg8S_rXKp0/exec
    const products =  axios.get('https://script.google.com/macros/s/AKfycbzPreliNySvtNTJGA702NkXsjBU4tm5L8fT99CwRuXsjWFxaX6w/exec?message=' + encodeURIComponent(messsage));
    props.context.checkout();
    
    setError("Your order has been completed. We'll reeach out to you over the phone.")
       setTimeout(function() {
           setError("No items in the Cart")
        }, 5000);
}
    
  return (
    <>
      <div className="hero is-primary">
        <div className="hero-body container">
          <h4 className="title">My Cart</h4>
        </div>
      </div>
          
      <br />
      <div className="container">
        {cartKeys.length ? (
          <div className="column columns is-multiline">
            {cartKeys.map(key => (
              <CartItem
                cartKey={key}
                key={key}
                cartItem={cart[key]}
                removeFromCart={props.context.removeFromCart}
              />
            ))}

        <div className="column is-one-third">
                <div className="field">
                <label className="label">Phone #: </label>
                <input
                  className="input"
                  type="text"
                  name="phone"
                  onChange={handleTextChange}
                />
              </div>
              <div className="field">
                <label className="label">Address: </label>
                <input
                  className="input"
                  type="text"
                  name="address"
                  onChange={handleTextChange}
                />
              </div>
              <div className="field">
                <label className="label">Delivery Details: </label>
                <input
                  className="input"
                  type="text"
                  name="deliver"
                  onChange={handleTextChange}
                />
              </div>
              
              <div className="title has-text-grey-light">Total: ${getTotal()}</div>
            </div>
            

            <div className="column is-12 is-clearfix">
              <br />
              <div className="is-pulled-right">
                <button
                  onClick={props.context.clearCart}
                  className="button is-warning "
                >
                  Clear cart
                </button>{" "}
                <button
                  className="button is-success"
                  onClick={onCheckout}
                >
                  Order
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="column">
            <div className="title has-text-grey-light">{error}</div>
          </div>
        )}
      </div>
    </>
  );
};

export default withContext(Cart);


//<div className="columns is-mobile is-centered">
//            
//          </div>